import { CompendiumPanel } from '@labsavvyapp/components'

export const generateCompendiaPanelDropdownItems = (compendiaPanels: CompendiumPanel[]) => {
  if (!compendiaPanels?.length) {
    return []
  }
  const compendiaPanelsDropdownItems = compendiaPanels.map((compendiaPanel: CompendiumPanel) => ({
    value: compendiaPanel.name,
    label: compendiaPanel.name,
    data: compendiaPanel,
  }))
  return compendiaPanelsDropdownItems
}
